import {
    AssignVesselToTagReq,
    CreateVesselTagReq,
    UpdateVesselTagReq,
    VesselTag,
    VesselTagResponse,
} from '../../../api/vessel-tags'
import {LocationIdType} from '../locations/state'
import {ErrorObject} from './action-creators'

export type LocationTagArrayMapType = Map<LocationIdType, Array<VesselTagResponse>>
export interface VesselTagReduxState {
    isFetchingTags: boolean
    vesselTags: VesselTag[]
    tagsForLocation: LocationTagArrayMapType
    errorResult: ErrorObject | undefined
    displayVesselSettingsForId: LocationIdType | undefined
    tagToCreateOrAssign: CreateVesselTagReq | AssignVesselToTagReq | null
    tagToUpdate: UpdateVesselTagReq | null
    searchedTerm: string
}

export const DEFAULT_VESSEL_TAGS_STATE: VesselTagReduxState = {
    isFetchingTags: true,
    vesselTags: new Array<VesselTag>(),
    tagsForLocation: new Map<LocationIdType, Array<VesselTagResponse>>(),
    errorResult: undefined,
    displayVesselSettingsForId: undefined,
    tagToCreateOrAssign: null,
    tagToUpdate: null,
    searchedTerm: '',
}
